<template>
  <div style="background:#131f30;;color:white;min-height:100vh;">
    <div style="padding:5px 20px;
    text-align: left;
    display: flex;
    align-items: center;font-weight:bold;"  @click='goback'>
        <mu-icon value='arrow_back'></mu-icon>
        {{this.$route.params.symbolName}}
        </div>
    
    
    <div class="hbox" v-if="currentInfo">
      <div>
        <div class="price">{{currentInfo.close.toFixed(2)}}  <strong class="green">{{this.$store.state.chuangxin[this.$route.params.symbolName.toLowerCase()].upradio|priceUp }}</strong></div>
        <div>
         距离-<strong style="color:red;">{{this.$store.state.expect}}</strong>期截止{{Math.floor(this.$store.state.miao/60)+"分"+(this.$store.state.miao%60).toFixed(0)}}秒
         <!-- <div v-if="this.$store.state.miao>this.$store.state.opentime*60-20||this.$store.state.miao<30" class="fengpan">封盘中</div> -->
        </div>
      </div>
      <div>
        <div>
          <label>高</label>
          <span>{{currentInfo.high.toFixed(2)}}</span>
        </div>
        <div>
          <label>低</label>
          <span>{{currentInfo.low.toFixed(2)}}</span>
        </div>
        <div>
          <label>24H量</label>
          <span>{{currentInfo.vol.toFixed(0)}}</span>
        </div>
      </div>
    </div>
   
    <div>
      <div id="chart" style="width:100vw;height:60vh"></div>
      <div class="bottom_box">
      <div>余额:{{user.balance.toFixed(2)}}</div>

      <div :class="{'bet_box':shownk,'bet_box1':!shownk}" >
           <van-field 
           style="padding: 5px;text-align: center;width: 100px;height: 32px;margin: 1px;"
           
           v-model="value"
           type= "number"

          
           />
          <!--  <van-button type="primary" size="small" @click="shownk=true">设置金额</van-button> -->
           <van-button type="primary" size="small" @click="setAllMoney()">全部金额</van-button>

           
      </div>
      <div class="buttonbox">
          
          <mt-button @click="toTrade('涨')" type="danger" style="width:40%">涨</mt-button>
          <mt-button @click="toTrade('跌')" type="primary" style="width:40%">跌</mt-button>
      </div>
      </div>
    </div>

<van-number-keyboard
  style = "color:black"
  :show="shownk"
  @blur="shownk = false"
  
  
  v-model="value"
/>

  </div>
</template>

<script>
import Api from "@/api";
import kj_utils from '@/kj_utils'
import NumberInput from '@/components/NumberInput'
import { Dialog,Toast } from 'vant';
import { Stepper,NumberKeyboard } from 'vant';



export default {
  data() {
    return {
      datalist: [],
      mychart: null,
      mychart1: null,
      areaSeries: null,
      volumeSeries: null,
      candleSeries: null,
      currentInfo: null,
      countSeries: null,
      type:'小众币',
      timer:-1,
      value:1,
      selectedType:"涨",
      shownk:false,
      lastsubmit:0,
      issubmit:false,
      lasttime:0,
    };
  },
   components:{
       NumberInput
  },
  unmounted() {
    clearInterval(this.timer);
  },
 
  computed:{
     user() {
       if(this.$store.state.user){
         return this.$store.state.user;
       }
       return {"balance":0.00}
     }
  },
  mounted() {
    this.mychart = LightweightCharts.createChart(chart, {
      width: chart.innerWidth,
      height: chart.innerHeight,
      localization:{
        locale:'zh'
      },
      rightPriceScale: {
        scaleMargins: {
          top: 0.1,
          bottom: 0.1
        },
        borderVisible: true,
        autoScale: true
      },

      layout: {
        backgroundColor: "#131722",
        textColor: "#d1d4dc"
      },
      grid: {
        vertLines: {
          color: "rgba(42, 46, 57, 0)"
        },
        horzLines: {
          color: "rgba(42, 46, 57, 0.6)"
        }
      },
      timeScale: {
        rightOffset: 12,
        barSpacing: 3,
        fixLeftEdge: false,
        lockVisibleTimeRangeOnResize: true,
        rightBarStaysOnScroll: true,
        borderVisible: true,
        borderColor: "#fff000",
        visible: true,
        timeVisible: true,
        secondsVisible: true,

        tickMarkFormatter: function(timePoint, tickMarkType, locale) {
          console.log(timePoint, tickMarkType, locale);
          let d=new Date(timePoint * 1000);
          let h = d.getUTCHours();
          let s = d.getUTCMinutes();
          return String(h+":"+s);
        }
      }
    });


    
   this.candleSeries = this.mychart.addAreaSeries({
     
      color:"#ff0000",
      lineColor: 'rgba(0, 150, 136, 1)',
      lineWidth: 2,
      scaleMargins: {
        top: 0.1,
        bottom: 0.3
      }
    });
    
    window.chart1 = this.mychart;

    
    this.$store.state.currentCode = this.$route.params.symbolName.toLowerCase();
    this.getDataByCode(this.$route.params.symbolName.toLowerCase());
    //this.timer=setInterval(()=>{this.getDataByCode(this.$route.params.symbolName.toLowerCase());},30000);
  },
  filters: {
    priceUp(item) {
      return (item*100).toFixed(2)+"%"
      //return (_.toFixed(2)+"%"
      //return (((item.close - item.open) / item.open) * 100).toFixed(2) + "%";
    }
  },
  methods: {

    

    onInput(value){
       Toast(this.value);
    },
    onDelete(){

    },
    setAllMoney() {
        this.value = Math.floor(this.$store.state.user.balance);
    },
    goback(){
      this.$router.go(-1);
    },
    bet(value){
      
       var t  = new Date().getTime();
       var dis = t-this.lasttime;
       console.log(dis);
       if(dis<1000){
           this.lasttime=t;

          return ;
       }
       else {
          this.lasttime=t;
       }
       
      if(!this.issubmit) {
        this.issubmit=true;
          var rqt = {
        code:this.$route.params.symbolName.toLowerCase(),
        expect:kj_utils.cp(""+this.$store.state.opentime)[0],
        value:value,
        bettype:this.selectedType,

      };
      console.log(kj_utils.cp(""+this.$store.state.opentime)[0]);
        Api.bet(rqt).then((res)=>{
          this.issubmit=false;
           this.$toast(res.data.message);
           if(res.data.success){
               this.$store.state.user = res.data.user;
           }
      });
    }
    else {

    }
      

      
    },
    toTrade(type){
      /*
     if(this.$store.state.miao>this.$store.state.opentime*60-15 ||this.$store.state.miao<30){
       this.$toast("封盘期间不能买入,请开盘后再试");
       return;


     
           }*/
       

      

         if(this.$store.state.user==null){
         this.$router.push("/login")
         return;
       }
      
      this.selectedType = type;
      var betvalue = parseFloat(this.value);
      if(!betvalue) {
        this.$toast("请输入金额")
        return;
      }
      if(betvalue<100) {
        this.$toast("买入金额不能小于100元")
        return;
      }
      
      Dialog.confirm({
        title:"买入确定",
        message:'买入金额'+this.value+""
      }).then(()=>{
          console.log("buybuy");
          this.bet(betvalue);
      }).catch(()=>{
             
      });

     

      
      
     
      /*
      if(this.type=='官方币'){
          this.$router.push('/home/tradeview/cro');
      }
      else {
          this.$router.push('/home/tradeview/'+this.$route.params.symbolName);

      }*/
    },
    getDataByCode(code){

      
        this.type = '小众币'
        this.getData(code)
      
    },
    getData1(code){
      Api.getDataFromUrl("https://api.coinke.io/api/url/https://api-aws.huobi.pro/market/history/kline?period=1day&size=1440&symbol="+code+"usdt").then(res=>{
        this.datalist = res.data.data;
        this.datalist = this.datalist.map(item => {
          item.time = item.id
          return item;
        });
       let tdata3 = this.datalist.map(item => {
          return { time: item.id, value: item.close };
        });

       
    
   
        this.candleSeries.setData(tdata3.reverse());
        this.mychart.timeScale().fitContent();
    
      })
    },
    getData(code) {
      
      Api.getTestData("1days", code, 1440).then(res => {
        this.datalist = res.data.data;
        
        let tdata3 = this.datalist.map(item => {
          //let t=moment(item.id).format("YYYY-MM-DD hh:mm:ss");
          return { time: parseInt(item.id+8*3600), value: item.close };
        });
        //console.log(tdata3.reverse());
        tdata3.reverse();
        this.candleSeries.setData(tdata3);
          //this.candleSeries.setData(tdata3);
        this.mychart.timeScale().fitContent();
        let n = this.datalist.length;
        this.currentInfo = this.datalist[0];
        let lasttime = this.datalist[0].id;
       
        let to = this.mychart.timeScale().getVisibleRange().to;
        this.mychart.timeScale().setVisibleRange({ from: to-1200, to: to });
      });
    }
  }
};
</script>

<style scoped>
.price {
  font-size: 1.5rem;
  font-weight: bold;
  color: #03ad8f!important;
}
label {
  color: gray;
}
.bottom_box {
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content:center;
  align-items:center;
}
.bet_box1 {
    padding-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content:center;
  align-items:center;
  width: 100%;

}
.bet_box {
   position: fixed;
   bottom: 250px;  
  padding-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content:center;
  align-items:center;
  z-index: 99;
  width: 100%;
}
.fengpan {
   background-color:red;
   color:white;
   padding:5px;
 }
.buttonbox {
   display: flex;
   margin-top:10px;
   justify-content: center;
   align-items: center;
   width:100vw;
  
}
</style>


// WEBPACK FOOTER //
// src/pages/MarketChart.vue